import { createContext, useEffect, useState } from 'react'

import { useWindowWidth } from '@awazevr/design-system.utils.react'

import { TmsContextType, TmsProviderProps } from './tmsProvider.types'
import {
  calculateSiteUXVersion,
  initTms,
  pushToDataLayer,
} from './tmsProvider.utils'

export const TmsContext = createContext<TmsContextType>({} as TmsContextType)

export function TmsProvider({
  children,
  id = 'GTM-KKPSZ36', // Default Website ID 
  gtmDataLayerName = 'dataLayer',
  pageLoadDataObjectName = 'utag_data',
  pageLoadDataObject,
}: TmsProviderProps) {
  const [init, setInit] = useState(false)
  const width = useWindowWidth()
  const siteUxVersion = calculateSiteUXVersion(width)
  const combinedPageLoadDataObject = {
    ...pageLoadDataObject,
    site_ux_version: siteUxVersion,
  }

  useEffect(() => {
    if (width && !init) {
      initTms({
        id,
        gtmDataLayerName,
        pageLoadDataObjectName,
        pageLoadDataObject: combinedPageLoadDataObject,
      })
      setInit(true)
    }
  }, [width, init])

  return (
    <TmsContext.Provider
      value={{
        id,
        gtmDataLayerName,
        pageLoadDataObjectName,
        pageLoadDataObject: combinedPageLoadDataObject,
        updateDataLayer: (eventType: any, eventName: any, eventData: any) => {
          const combinedEventData = {
            ...eventData,
            site_ux_version: calculateSiteUXVersion(window.innerWidth),
          }
          return pushToDataLayer(eventType, eventName, combinedEventData)
        },
      }}
    >
      {children}
    </TmsContext.Provider>
  )
}
